import { ApprovalRequest } from './ApprovalRequest.model';
import { HumanAssistRequest } from './HumanAssistRequest.model';

export type PendingRequestType = 'TOOL_APPROVAL' | 'HUMAN_ASSIST';

export interface ToolApprovalPendingRequest extends ApprovalRequest {
  type: 'TOOL_APPROVAL';
}

export interface HumanAssistPendingRequest extends HumanAssistRequest {
  type: 'HUMAN_ASSIST';
}

export type PendingRequest = ToolApprovalPendingRequest | HumanAssistPendingRequest;

export function isToolApprovalRequest(request: PendingRequest): request is ToolApprovalPendingRequest {
  return request.type === 'TOOL_APPROVAL';
}

export function isHumanAssistRequest(request: PendingRequest): request is HumanAssistPendingRequest {
  return request.type === 'HUMAN_ASSIST';
}

/**
 * Merges approval requests and human assist requests into a unified list,
 * sorted by createdAt in descending order (newest first).
 */
export function mergePendingRequests(
  approvalRequests: ApprovalRequest[],
  humanAssistRequests: HumanAssistRequest[]
): PendingRequest[] {
  const toolApprovals: ToolApprovalPendingRequest[] = approvalRequests.map((req) => ({
    ...req,
    type: 'TOOL_APPROVAL' as const,
  }));

  const assists: HumanAssistPendingRequest[] = humanAssistRequests.map((req) => ({
    ...req,
    type: 'HUMAN_ASSIST' as const,
  }));

  return [...toolApprovals, ...assists].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
}
